import { render, staticRenderFns } from "./ControlsSection.vue?vue&type=template&id=5fbd1bb4&scoped=true&"
import script from "./ControlsSection.vue?vue&type=script&lang=js&"
export * from "./ControlsSection.vue?vue&type=script&lang=js&"
import style0 from "./ControlsSection.vue?vue&type=style&index=0&id=5fbd1bb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd1bb4",
  null
  
)

export default component.exports